import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./File.module.scss";
import { FileIcon } from "@/frontend/shared/assets/icons";

export function File({ name }: { name: string }) {
  return (
    <div className={styles.mainContainer}>
      <FileIcon />
      <Typography variant="label-4" color="greyscale700">
        {name}
      </Typography>
    </div>
  );
}
